export default __webpack_public_path__ + "static/media/johor2019B.0ee1d926.jpg";